export default function () {
  if (document.getElementById('leads-app')) {
    // eslint-disable-next-line no-unused-expressions
    import(/* webpackChunkName: "leads-vue-app" */ '../_03_organisms/leads/main');
  }
}
